

export default function RightTopArrow(props) {

    return (
        <div
            className="d-none d-lg-flex row sas-ping-pong-row-with-arrow w-100 sas-ping-pong-row-with-arrow-right">
            <div className="col-3">
                <div
                    className="sas-ping-pong-arrow sas-ping-pong-arrow-right  text-sas-color-gold">
                    <svg width="130"
                         height="130"
                         viewBox="0 0 130 130"
                         fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M125.918 5.84583C116.987 66.9711 62.1418 96.6614 4.8859 103.412C3.90271 103.53 3.19581 104.423 3.31361 105.406C3.43141 106.389 4.32394 107.096 5.30712 106.978C64.167 100.041 120.29 69.2002 129.47 6.36229C129.615 5.38363 128.935 4.47295 127.952 4.32796C126.973 4.18297 126.063 4.86264 125.918 5.84583Z"
                            fill="currentColor"/>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.17112 105.07C8.71744 103.207 11.9389 100.906 12.2968 100.634C21.9973 93.2667 30.0349 84.7896 37.1121 74.8445C37.6875 74.038 37.4971 72.9143 36.6906 72.3389C35.8842 71.7635 34.7606 71.9539 34.1852 72.7604C27.3255 82.4065 19.5326 90.6299 10.1221 97.775C9.57386 98.1918 2.32897 103.361 0.942538 104.517C0.371655 104.988 0.195077 105.432 0.163361 105.541C-0.0269333 106.112 0.0863017 106.56 0.240349 106.886C0.417051 107.253 0.856425 107.788 1.70822 108.06C2.60079 108.341 4.58538 108.468 5.08377 108.54C12.6004 109.655 21.0867 110.244 28.8117 112.382C36.1788 114.421 42.8616 117.874 47.1478 124.792C47.6688 125.635 48.7789 125.893 49.6216 125.372C50.4643 124.851 50.7227 123.741 50.2017 122.898C45.4081 115.164 38.0046 111.2 29.7721 108.921C22.0923 106.796 13.6832 106.152 6.17112 105.07Z"
                            fill="currentColor"/>
                    </svg>
                </div>
            </div>
        </div>
    )
}